import React from 'react'
import styled from 'styled-components'
import { Button } from 'antd'

const ButtonLinkStyled = styled(Button)`
  color: ${({ theme }) => theme.black};
  border: none;
  background: none;
  
  span {
    font-weight: 400;
  }
`

// eslint-disable-next-line react/prop-types
const ButtonLink = ({ children, ...props }) => (
  <ButtonLinkStyled {...props}>
    {children}
  </ButtonLinkStyled>
)

export default ButtonLink
